// src/layouts/certificaciones/certificate/CertificateWithImages.jsx
import React from "react";

// Assets (ajusta si tus rutas son distintas)
import Fondo       from "assets/images/cert/fondo.jpg";
import Liston      from "assets/images/cert/liston-verde.png";
import Sello       from "assets/images/cert/sello.png";          // fallback si no hay award
import FirmaGGK    from "assets/images/cert/firmaGGK.png";
import TextoHead   from "assets/images/cert/texto-certificado.png";

// Medallas (mismo folder para consistencia)
import MedalDiamond from "assets/images/cert/medalla-diamante.png";
import MedalPlatinum from "assets/images/cert/medalla-platino.png";
import MedalGold     from "assets/images/cert/medalla-oro.png";

// util: quita acentos y pasa a minúsculas
const norm = (s = "") =>
  s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

// prioriza diamante > platino > oro
function pickMedal(award = "") {
  const t = norm(award);
  if (/\bdiamante\b/.test(t) || /\bdiamond\b/.test(t)) return MedalDiamond;
  if (/\bplatino\b/.test(t)  || /\bplatinum\b/.test(t)) return MedalPlatinum;
  if (/\boro\b/.test(t)      || /\bgold\b/.test(t))     return MedalGold;
  return null; // sin award conocido → usamos sello genérico
}

export default function CertificateWithImages({ cert, selloNombre }) {
  const artist   = cert?.artist || "";
  const title    = cert?.title  || "";
  const award    = cert?.award  || "";
  const codigo   = cert?.catalog_identity || cert?.id || "";
  const unidades = Number(cert?.sale_units || 0).toLocaleString("es-MX");
  const sello    = selloNombre || cert?.record_label_name || cert?.record_label || "—";
  const fecha    = (() => {
    try {
      const d = new Date(cert?.post_at || cert?.created_at || Date.now());
      return new Intl.DateTimeFormat("es-MX", { day: "numeric", month: "long", year: "numeric" }).format(d);
    } catch { return String(cert?.post_at || cert?.created_at || "").slice(0, 10); }
  })();

  // 👉 medalla dinámica
  const medalSrc = pickMedal(award);

  return (
    <div
      style={{
        width: 794, height: 1123, position: "relative",
        fontFamily: "Arial, Helvetica, sans-serif", color: "#222",
      }}
    >
      {/* Fondo */}
      <img src={Fondo} alt="" crossOrigin="anonymous" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />

      {/* Listón AMPROFON */}
      <img
        src={Liston}
        alt="AMPROFON"
        crossOrigin="anonymous"
        style={{ position: "absolute", top: 120, left: "50%", transform: "translateX(-50%)", width: 450 }}
      />

      {/* Texto “CERTIFICADO” + ornamentos */}
      <img
        src={TextoHead}
        alt="CERTIFICADO"
        crossOrigin="anonymous"
        style={{
          position: "absolute",
          top: -30,
          left: "50%",
          transform: "translateX(-50%)",
          width: 760,
          opacity: 0.92,
          zIndex: 2,
        }}
      />

      {/* Chip con nombre del sello */}
      <div
        style={{
          position: "absolute",
          top: 320,
          left: "50%",
          transform: "translateX(-50%)",
          background: "#39b36f", color: "#fff", borderRadius: 20, padding: "8px 18px",
          fontWeight: 700, minWidth: 220, textAlign: "center",
          boxShadow: "0 3px 0 rgba(0,0,0,0.12)",
          zIndex: 5,
        }}
      >
        {sello}
      </div>

      {/* Texto principal */}
      <div style={{ position: "absolute", top: 385, left: 100, width: 594, fontSize: 15, lineHeight: 1.7, textAlign: "center", zIndex: 2 }}>
        <p style={{ margin: 0 }}>Estimados Señores:</p>
        <p style={{ margin: "14px 0" }}>
          Atendiendo su solicitud, mediante la cual nos solicitan verificar y certificar las<br/>
          ventas del fonograma titulado <strong>“{title}”</strong> de <strong>{artist}</strong>.<br/>
          Con código de producto {codigo || "—"} hacemos constatar lo siguiente:
        </p>
        <p style={{ margin: "14px 0" }}>
          Una vez revisado el reporte de ventas y los datos de etiqueta correspondientes,<br/>
          verificamos que el fonograma antes detallado ha alcanzado a esta fecha la venta<br/>
          de <strong>{unidades} UNIDADES</strong>.
        </p>
        {award && (
          <p style={{ margin: "14px 0" }}>
            La presente certificación se hace con objeto de otorgar <strong>{award}</strong> por más de<br/>
            <strong>{unidades} UNIDADES VENDIDAS</strong>. Extendemos la presente constancia con<br/>
            fundamento en los acuerdos tomados por la Asamblea de Asociados.
          </p>
        )}
        <p style={{ marginTop: 28, textAlign: "left" }}>Atentamente</p>
      </div>

      {/* Firma + datos */}
      <div style={{ position: "absolute", left: 0, right: 0, bottom: 150, textAlign: "center" }}>
        <img src={FirmaGGK} alt="Firma" crossOrigin="anonymous" style={{ height: 100, opacity: 0.95 }} />
        <div style={{ fontWeight: 700, marginTop: 6 }}>Lic. Guillermo King</div>
        <div>Director General</div>
        <div style={{ marginTop: 6, fontSize: 12 }}>{fecha}</div>
      </div>

      {/* Medalla dinámica (fallback al sello genérico si no hay award) */}
      <img
        src={medalSrc || Sello}
        alt={medalSrc ? "Medalla" : "Sello"}
        crossOrigin="anonymous"
        style={{ position: "absolute", right: 100, bottom: 150, width: 180, height: "auto" }}
      />
    </div>
  );
}
